module.exports = __webpack_public_path__ + "static/media/roanoke-inside-christmas.9b3497f9.png";